import { PdfviewStateDefaults } from "@pdfking/pdfview"
import { CreateRouter, LazyView } from "@pdfking/router"

import { SLUGS } from "./docs/Packages"
import { About } from "./pages/About"
import { DocsRoute } from "./pages/DocsRoute"
import { Home } from "./pages/Home"
import type { DocsTarget } from "./types/DocsTarget"

export const { Router, Link, Navigate, Replace, CreateHref } = CreateRouter({
  // path routes: real urls with a final slash, each prerendered to its own
  // <path>index.html — what a static server serves for a folder
  home: { path: "/", view: Home, defaults: {}, hash: false },
  about: { path: "/about/", view: About, defaults: {}, hash: false },
  // /docs/, then each package's index and pages below it; an export on a page
  // is a plain fragment (#Channel), never a route
  docs: {
    path: "/docs/:package?/:page?/",
    view: DocsRoute,
    defaults: { package: undefined, page: undefined },
    hash: false,
    codec: {
      encode: (props: DocsTarget) => ({ package: props.package, page: props.page }),
      // an unknown package in the url is /docs/
      decode: (params: { package?: string; page?: string }) => {
        const slug = SLUGS.find(slug => slug === params.package)
        return { package: slug, page: (slug && params.page) || undefined }
      },
    },
  },
  // the viewer, its whole state in the hash (#/viewer/…): client-only, the
  // prerender never sees a hash, and its chunk loads on first open
  viewer: {
    path: "/viewer/:data?",
    view: LazyView(() => import("./views/Viewer").then(module => module.Viewer)),
    defaults: PdfviewStateDefaults,
  },
})
